import React, {useEffect, useState} from "react"
import api, {requestFailed} from "../Scripts/api"
import Countdown from "../Components/Countdown"
import Loading from "../Components/Loading"
import StepList from "../Components/StepList"

function msUntilNextSunday() {
    const now = new Date()
    const daysUntilSunday = (7 - now.getUTCDay()) % 7
    const next = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + daysUntilSunday, 0, 0, 0, 0))
    if (next <= now) next.setUTCDate(next.getUTCDate() + 7)
    return next.getTime() - now.getTime()
}

function Challenge() {

    const [challengeID, setChallengeID] = useState(0)
    const [category, setCategory] = useState()
    const [steps, setSteps] = useState()
    const [notFound, setNotFound] = useState(false)

    const getChallenge = () => {
        api.get(`/api/getwc`).then((response) => {
            const challenge = response.data[0]
            if (!challenge) {
                setNotFound(true)
                return
            }
            let challengeSteps = challenge.steps
            if (typeof challengeSteps === "string") {
                try {
                    challengeSteps = JSON.parse(challengeSteps)
                } catch (error) {
                    challengeSteps = null
                }
            }
            if (!Array.isArray(challengeSteps)) {
                setNotFound(true)
                return
            }
            setNotFound(false)
            setChallengeID(challenge.id)
            setCategory(challenge.category)
            setSteps(challengeSteps)
        }).catch((error) => {
            requestFailed(error)
            setNotFound(true)
        })
    }

    useEffect(() => {
        getChallenge()

        let timeoutId
        const scheduleNext = () => {
            timeoutId = setTimeout(() => {
                getChallenge()
                scheduleNext()
            }, msUntilNextSunday())
        }
        scheduleNext()

        return () => {
            clearTimeout(timeoutId)
        }
    }, [])

    return (
        <div>
            <h1 id="challengetitle">{category ? category.toUpperCase() : ''} CHALLENGE</h1>
            <Countdown challengeID={challengeID}/>
            {steps &&
                <div id="steplist">
                    <StepList steps={steps}/>
                </div>
            }
            {!steps && notFound && <p>no active challenge — check back Sunday.</p>}
            {!steps && !notFound && <Loading/>}
        </div>
    )
}

export default Challenge;
